<template>
  <div id="login" style="height: 100%">
    <div class="imgBg p_r" id="index">
      <div class="loginDiv">
        <div v-if="loginSelt === 1">
          <section>
            <ul>
              <li>
                <i class="icon iconfont iconyonghu"></i>
                <input v-model="goInfo.name" type="text" placeholder="请输入用户名">
              </li>
              <li>
                <i class="icon iconfont iconshangjiayunyingxitongdaohangicon-"></i>
                <input v-model="goInfo.pwd" type="password" placeholder="请输入密码">
              </li>
              <li style="background: none">
                <input @change="radio($event)" type="checkbox" class="allCheckbox" id="loginRadio" v-model="remBer">
                <label for="loginRadio"></label><label for="loginRadio"><span class="c_p m_l_5">记住密码</span></label>
              </li>
            </ul>
            <div style="width: 100%" class="t_c">
              <button :disabled="goInfo.name === '' || goInfo.pwd === ''" class="loginButn" style="width: 80%" @click="goUrl()">登录</button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let Time
export default {
  name: 'login',
  data () { // 所有的数据都写在里面
    return {
      msg: '',
      account: '',
      myPassword: '',
      token: this.$route.query.token,
      loginSelt: 1,
      goInfo: {
        name: '',
        pwd: ''
      },
      remBer: '',
      flag: true, // 节流阀，防止连续点击切换,
      autoSwitch: null,
      urlUserName: '',
      postData: {
        nameid: '',
        timestamp: '',
        code: ''
      }
    }
  },
  created () {
    console.log(this.token)
    // if (this.token) {
    //   window.localStorage.setItem('coeToken', this.token)
    //   this.goUrl()
    // }
    // if (localStorage.rememberPsw && localStorage.rememberPsw === 'true') {
    //   this.remBer = localStorage.rememberPsw
    //   this.goInfo.name = localStorage.name
    //   this.goInfo.pwd = localStorage.pwd
    // }
    console.log(this.$route, this.$route.query)
    var nameid = this.GetQueryString('nameid')
    var timestamp = this.GetQueryString('timestamp')
    var code = this.GetQueryString('code')
    console.log(nameid, timestamp, code)
    if (nameid && timestamp && code) {
      this.postData.nameid = nameid
      this.postData.timestamp = timestamp
      this.postData.code = code
      this.ssoLogin()
    } else {
      if (localStorage.coeToken && localStorage.coeToken !== '') {
        this.$router.replace({
          name: 'index'
        })
      } else {
        if (process.env.NODE_ENV === 'production') {
          window.location.href = this.$baseUrl + 'Home/login'
        }
      }
    }
  },
  destroyed () {
    clearInterval(Time)
    clearInterval(this.autoSwitch)
  },
  mounted () {
    // console.log(this.$route.query.userName)
  },
  methods: {
    radio (e) {
      localStorage.rememberPsw = this.remBer
    },
    goUrl () {
      console.log('-------------')
      this.$axiox.get('/api/login/LoginBySystem?name=' + this.goInfo.name + '&pwd=' + this.goInfo.pwd).then(msg => {
        // console.log('======', msg)
        localStorage.coeToken = msg.data.token
        localStorage.logInfo = JSON.stringify(msg.data)
        // this.$commonJs.alertTips({
        //   type: 'success',
        //   title: '成功',
        //   content: '登录成功',
        //   stayTime: 5
        // })
        if (this.remBer === 'true') {
          localStorage.name = this.goInfo.name
          localStorage.pwd = this.goInfo.pwd
        }
        this.$router.push({
          name: 'index'
        })
        // window.location.reload()
      })
    },
    ssoLogin () {
      let url = this.$commonJs.returnQuery('/api/login/jwtToken', this.postData)
      this.$axiox.get(url).then(msg => {
        localStorage.coeToken = msg.data.token
        localStorage.logInfo = JSON.stringify(msg.data)
        location.href = '//' + window.location.host + '/#/index'
      })
    },
    GetQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.loginButn {
  background-color: #12ABDB;
  border-radius: 5px;
  border: 1px solid transparent;
  padding: 10px 20px;
  color:#fff;
  outline: none;
  font-size: 12px;
}
  .allRadio + label {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid #0070AD;
    border-radius: 50%;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
    margin:0 10px 0 0;
  }
.allRadio:checked + label{
  border: 1px solid #0070AD;
  background-color: white;
}
.allRadio:checked + label:after{
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius:10px ;
  position: absolute;
  top: 3px;
  left: 3px;
  background-color: #0070AD;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/login.vue